import { getLocaleFirstDayOfWeek } from '@angular/common';
import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NativeDateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { startWith, tap } from 'rxjs/operators';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    public locale = inject(LOCALE_ID);

    public constructor() {
        const translate = inject(TranslateService);

        super();
        translate.onLangChange
            .pipe(
                startWith({ lang: translate.currentLang }),
                tap((locale) => this.setLocale(locale.lang)),
                takeUntilDestroyed()
            )
            .subscribe();
    }

    public override getFirstDayOfWeek(): number {
        return getLocaleFirstDayOfWeek(this.locale);
    }
}
